import { useSelector } from 'react-redux';
import { SelectedTransactionOrdering } from '../../redux/localReports/localReports.proptype';
import { selectOrderedTransactions } from '../../selectors';

export const useSelectedOrderedTransactions = (): SelectedTransactionOrdering => {
  const selectedTransactionsOrdering = useSelector(selectOrderedTransactions);

  return selectedTransactionsOrdering;
};
